import * as OAuth from "oauth2";
import * as Broker from "message-broker";
import * as Updater from "./maintainer/updater";
import * as Messenger from "./messenger";

const script = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register("/sw.js", {
        type: "module",
        scope: "/",
      });

      try {
        await registration.update();
      } catch (updateErr) {
        // Ex: Si pas de connexion internet
        console.warn("[SW] update failed, keeping the last one:", updateErr);
      }

      await navigator.serviceWorker.ready;

      if (!navigator.serviceWorker.controller) {
        await Messenger.sendMessage({
          type: "HARD_RELOAD",
        });
      }

      navigator.serviceWorker.addEventListener("message", (event) => {
        if (["LOG", "LOG_WARNING", "LOG_ERROR"].includes(event.data?.type)) {
          const message = "[Service Worker] " + event.data.message;

          if (Broker.isNativeApp()) {
            Broker.sendToNative({
              type: "log",
              payload: {
                level:
                  event.data?.type === "LOG"
                    ? "log"
                    : event.data?.type === "LOG_WARNING"
                      ? "warning"
                      : "error",
                message: message,
              },
            });
          } else {
            if (event.data.type === "LOG") {
              console.log(message);
            } else if (event.data.type === "LOG_WARNING") {
              console.warn(message);
            } else if (event.data.type === "LOG_ERROR") {
              console.error(message);
            }
          }
        }
      });

      //Transfert des dépendances du service worker
      const token = OAuth.getAccessToken();
      const user = OAuth.userFromStorage();
      await Updater.sendAuth(token, user);
    } catch (err) {
      console.error(err);
    }
  }
};
export default script;
